<div style="width: 100%; overflow-y: auto; flex: 1; max-height: 100%;" data-cy="list-container-div">
  <div #el class="tdo-list-item" (click)="onListItemSelected($event, d)" [ngClass]="{'tdo-list-item-selected': selectedItem === d}" *ngFor="let d of dataSource" data-cy="list-item-div">{{d[propertyName]}}</div>
</div>
